import React, { useState } from 'react'
import { Loader2 } from 'lucide-react'

interface ToggleSwitchProps {
  label: string
  value: boolean | null
  onToggle: (value: boolean) => Promise<void>
  className?: string
}

export default function ToggleSwitch({ 
  label, 
  value, 
  onToggle, 
  className = ""
}: ToggleSwitchProps) {
  const [isSaving, setIsSaving] = useState(false)

  const handleToggle = async () => {
    const newValue = !value
    try {
      setIsSaving(true)
      await onToggle(newValue)
    } catch (error) {
      console.error('Error toggling:', error)
    } finally {
      setIsSaving(false)
    }
  }

  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      <button
        onClick={handleToggle}
        disabled={isSaving}
        className={`
          relative inline-flex h-5 w-9 items-center rounded-full transition-colors
          ${value ? 'bg-indigo-600 dark:bg-indigo-500' : 'bg-gray-200 dark:bg-gray-600'}
          ${isSaving ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
        `}
        title={`${label}: ${value ? 'Aktiviert' : 'Deaktiviert'}`}
      >
        <span
          className={`
            inline-block h-4 w-4 transform rounded-full bg-white transition-transform
            ${value ? 'translate-x-4' : 'translate-x-0.5'}
          `}
        />
        {isSaving && (
          <div className="absolute inset-0 flex items-center justify-center">
            <Loader2 className="h-3 w-3 animate-spin text-white" />
          </div>
        )}
      </button>
      <span className="text-sm font-medium text-gray-700 dark:text-gray-200">{label}</span>
    </div>
  )
}
